import React from 'react'

import { styled } from '@mui/material'

import { LeafletMap } from '../LeafletMap/LeafletMap'

export type AddressFieldMapProps = {
  children?: React.ReactNode
}

export const AddressFieldMap: React.FC<AddressFieldMapProps> = ({ children }) => {
  return (
    <StyledMapContainer>
      <LeafletMap
        drawControl={false}
      >
        {children}
      </LeafletMap>
    </StyledMapContainer>
  )
}

const StyledMapContainer = styled('div')`
  width: 100%;
  height: 400px;
`